export default __webpack_public_path__ + "static/media/unchecked-checkbox.f0b713e6.svg";